import PropTypes from "prop-types";

import { Button } from "../UI";

import classNames from "classnames";
import classes from "./QuantityControls.module.css";

const QuantityControls = (props) => {
  const { quantity, onPlus, onMinus, isPlusDisabled, className } = props;

  // TODO: add the logic of increasing, decreasing, cart_quantity and disable in this component

  return (
    <div className={classNames(classes["quantity-controls"], className)}>
      <Button
        className={classNames(
          classes["quantity-controls__btn"],
          "flex justify-center items-center"
        )}
        type="primary"
        disabled={isPlusDisabled}
        onClick={onPlus}
      >
        +
      </Button>

      <span
        className={classNames(
          classes["quantity-controls__quantity"],
          "numeric-content"
        )}
      >
        {quantity > 99 ? "+99" : quantity}
      </span>

      <Button
        className={classes["quantity-controls__btn"]}
        type="secondary"
        disabled={quantity <= 1}
        onClick={onMinus}
      >
        -
      </Button>
    </div>
  );
};

export default QuantityControls;

QuantityControls.propTypes = {
  quantity: PropTypes.number.isRequired,
  onPlus: PropTypes.func.isRequired,
  onMinus: PropTypes.func.isRequired,
  isPlusDisabled: PropTypes.bool,
  className: PropTypes.string,
};
